import _ from 'lodash';
import { FiscalRepSubscriptionRowFragment } from '@src/generated/graphql';
import { FiscalRepSubscriptionStatusInfo } from './types';

export function getFiscalRepSubscriptionStatusInfo(
  subscription: FiscalRepSubscriptionRowFragment,
): FiscalRepSubscriptionStatusInfo {
  if (!subscription.isActive) {
    const completedCancellationRequest = _.maxBy(
      subscription.cancellationRequests.filter(
        (c) => c.completedSuccessfullyAt,
      ),
      (c) => c.completedSuccessfullyAt,
    );
    return {
      state: 'CANCELLED',
      badge: 'INACTIVE',
      signedContractFileId: completedCancellationRequest?.signedContractFileId,
    };
  }
  const pendingCancellationRequest = subscription.cancellationRequests.find(
    (c) => !c.isComplete,
  );
  if (!pendingCancellationRequest) {
    if (subscription.isUnpaid) {
      return {
        state: 'PENDING_CUSTOMER_ACTION',
        badge: 'UNPAID',
        // t('fiscal_rep:dashboard.order_item.unpaid', 'Your subscription is unpaid. Please update your payment method.')
        message: 'fiscal_rep:dashboard.order_item.unpaid',
        canUpdatePaymentMethod: true,
        canCancel: true,
      };
    }

    return {
      state: 'COMPLETED',
      badge: null,
      canCancel: true,
      canUpdatePaymentMethod: true,
      isInactive: false,
    };
  }
  if (
    (pendingCancellationRequest.type === 'AGREEMENT_MEMORANDUM' ||
      pendingCancellationRequest.type === 'ELECTRONIC_NOTIFICATIONS') &&
    pendingCancellationRequest.contractUrl
  ) {
    return {
      state: 'PENDING_CUSTOMER_ACTION',
      canCancel: false,
      canUpdatePaymentMethod: false,
      signAgreementUrl: pendingCancellationRequest.contractUrl,
      // t('fiscal_rep:dashboard.order_item.fiscal_rep_cancellation_signature_required', 'Please sign the agreement to cancel your fiscal representation with Bordr. Your credit card will not be charged.')
      message:
        'fiscal_rep:dashboard.order_item.fiscal_rep_cancellation_signature_required',
    };
  }

  const documentStatus =
    pendingCancellationRequest.proofOfCancellationDocument?.status;

  if (documentStatus === 'PENDING' || documentStatus === 'ACCEPTED') {
    return {
      state: 'PENDING_BORDR_ACTION',
      badge: 'CANCELLATION_PENDING',
      // t('fiscal_rep:dashboard.order_item.pending_cancellation_request', 'Your cancellation request is being reviewed by the Bordr team. No action needed.')
      message: 'fiscal_rep:dashboard.order_item.pending_cancellation_request',
      canUpdatePaymentMethod: true,
    };
  }
  if (documentStatus === 'REJECTED') {
    return {
      state: 'PENDING_CUSTOMER_ACTION',
      // t('fiscal_rep:dashboard.order_item.cancellation_request_rejected', 'Please upload a new document for your cancellation request.')
      message: 'fiscal_rep:dashboard.order_item.cancellation_request_rejected',
      needsReupload: true,
      canUpdatePaymentMethod: true,
    };
  }
  return {
    state: 'PENDING_CUSTOMER_ACTION',
    // t('fiscal_rep:dashboard.order_item.cancellation_request_invalid', 'Your cancellation request is invalid. Please contact support.')
    message: 'fiscal_rep:dashboard.order_item.cancellation_request_invalid',
    canUpdatePaymentMethod: true,
  };
}
